/**
 * Disable path mode confirmation (AC-039, D-4): destructive SDialog pattern — the header X (left) is the single
 * dismiss, named "Cancel"; the error-coloured primary names the action. MUI Dialog traps focus and returns it to
 * the opener (`baseUrl.disableBtn`) on close.
 */
import React from 'react';
import { Typography } from '@mui/material';
// Subpath import: the ui-components root barrel is not jest-safe (import.meta via data-pickers).
import { SDialog } from '@modules/ui-components/dialogs/SDialog';
import { CUSTOM_DOMAIN_TEST_IDS } from '@modules/custom-domains/testIds';
import { PATH_MODE_COPY } from '@modules/custom-domains/components/articlePathModeCopy';

export interface DisablePathModeDialogProps {
  open: boolean;
  articleHost: string;
  /** Host of the customer's site (from the stored base URL). */
  siteHost: string;
  onClose(): void;
  onConfirm(): void;
  /** After the close transition (and MUI's focus restore): lets the caller move focus to a stable element. */
  onExited?(): void;
}

export function DisablePathModeDialog({ open, articleHost, siteHost, onClose, onConfirm, onExited }: DisablePathModeDialogProps) {
  const copy = PATH_MODE_COPY.disableDialog;
  return (
    <SDialog
      open={open}
      onClose={onClose}
      title={copy.title}
      maxWidth="xs"
      closeButtonAriaLabel={copy.dismissLabel}
      slotProps={{ transition: { onExited } }}
      primaryAction={{
        label: copy.confirm,
        onClick: onConfirm,
        color: 'error',
        'data-testid': CUSTOM_DOMAIN_TEST_IDS.baseUrl.disableConfirm,
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>{copy.body(articleHost)}</Typography>
      <Typography variant="body2" color="text.secondary">{copy.secondary(siteHost)}</Typography>
    </SDialog>
  );
}

export default DisablePathModeDialog;
